import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../FreeCataloges.jsx/FreeCataloge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faShieldHalved,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

const products = [
  { id: 1, name: "Cotton Saree", image: "./assets/sh1.jpg" },
  { id: 3, name: "Dyed Saree", image: "./assets/sh2.jpg" },
  { id: 5, name: "Cotton- Blue Saree", image: "./assets/sh3.jpg" },
  { id: 6, name: "Wine red Saree", image: "./assets/sh4.jpg" },
  { id: 4, name: "Bandhini Saree", image: "./assets/sh5.jpg" },
  { id: 8, name: "Checks Saree", image: "./assets/sh6.jpg" },
  { id: 2, name: "Printed Saree", image: "./assets/sh7.jpg" },
  { id: 9, name: "Jari Border Saree", image: "./assets/sh8.jpg" },
];

const SiddhiCollectionCata = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [highlight, setHighlight] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleReachEnd = () => {
    if (swiperInstance) {
      const isEnd = swiperInstance.isEnd;
      const navigationButton = document.querySelector(".swiper-button-next");
      if (navigationButton) {
        navigationButton.style.display = isEnd ? "none" : "block";
      }
    }
  };

  const handleReachStart = () => {
    if (swiperInstance) {
      const isBeginning = swiperInstance.isBeginning;
      const navigationButton = document.querySelector(".swiper-button-prev");
      if (navigationButton) {
        navigationButton.style.display = isBeginning ? "none" : "block";
      }
    }
  };

  const handleProductClick = () => {
    setActiveSection("products");
  };

  const renderContent = () => {
    switch (activeSection) {
      case "products":
        return (
          <div className="swiper-container">
            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              slidesPerView={1}
              spaceBetween={10}
              pagination={{ clickable: true }}
              navigation={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              onSwiper={setSwiperInstance}
              onReachEnd={handleReachEnd}
              onReachBeginning={handleReachStart}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 4, spaceBetween: 40 },
                1024: { slidesPerView: 7, spaceBetween: 30 },
              }}
              className="mySwiper"
            >
              {products.map((product) => (
                <SwiperSlide key={`product-${product.id}`}>
                  <div className="card" onClick={handleProductClick}>
                    <img src={product.image} alt={product.name} />
                    <p>{product.name}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        );

      default:
        return (
          <div>
            <div className="swiper-container">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                slidesPerView={1}
                spaceBetween={10}
                pagination={{ clickable: true }}
                navigation={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                onSwiper={setSwiperInstance}
                onReachEnd={handleReachEnd}
                onReachBeginning={handleReachStart}
                breakpoints={{
                  640: { slidesPerView: 2, spaceBetween: 20 },
                  768: { slidesPerView: 4, spaceBetween: 40 },
                  1024: { slidesPerView: 7, spaceBetween: 30 },
                }}
                className="mySwiper"
              >
                {products.map((product) => (
                  <SwiperSlide key={`product-${product.id}`}>
                    <div className="card">
                      <img src={product.image} alt={product.name} />
                      <p>{product.name}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="welcome">
              <h1>Welcome to the SIDDHI COLLECTION Company</h1>
              <p>
                SIDDHI COLLECTION is a leading name in the Indian garment
                manufacturing industry, proudly operating from the textile
                capital of India—Tirupur, Tamil Nadu. With 1 year of industry
                experience, SIDDHI COLLECTION has quickly established a
                reputation for delivering high-quality cotton and fabric Saree
                tailored for men and women. The company focuses on maintaining
                product excellence, customer satisfaction, and timely delivery.
              </p>

              <p>
                As a dedicated Saree manufacturer, SIDDHI COLLECTION specializes
                in creating stylish, durable, and comfortable apparel suitable
                for all seasons. Their main product line includes a wide variety
                of Men’s and Women’s Saree, crafted from premium-grade cotton.
                These garments are known for their soft texture, breathable
                quality, and modern fits, making them ideal for both casual and
                semi-formal wear. Whether it's round neck, V-neck, polo, or
                custom-printed Saree, South Cotton Fabs ensures each piece meets
                stringent quality standards.
              </p>
              <h2>We Deals in All kind of Sarees</h2>
              <p>
                Tirupur is globally recognized for its excellence in textile
                production, and SIDDHI COLLECTION Sarees proudly upholds this
                legacy. By utilizing advanced machinery and skilled
                craftsmanship, the company offers a sophisticated fusion of
                traditional saree artistry and modern fashion sensibilities.
                Each saree is crafted with precision, emphasizing premium fabric
                quality, intricate weaving, vibrant color combinations, and
                elegant finishes.
              </p>

              <p>
                A core strength of SIDDHI COLLECTION Sarees is its
                customer-focused approach. The company accepts bulk orders and
                provides various customization options such as embroidery work,
                unique border designs, matching blouse pieces, and custom
                lengths or styles to meet the unique preferences of each client.
                From boutique collections to festive and ceremonial wear, SIDDHI
                COLLECTION Sarees serves a wide range of buyers with
                dependability and finesse. The team is driven by values of
                innovation, integrity, and quality, working closely with clients
                to deliver sarees that balance traditional charm with
                contemporary appeal. Additionally, the company emphasizes
                sustainable practices and ethical manufacturing.
              </p>

              <p>
                With a growing network of customers across India—including
                ethnic wear retailers, fashion entrepreneurs, and
                exporters—SIDDHI COLLECTION Sarees is emerging as a trusted name
                in the saree industry. For businesses looking for a reliable
                source of cotton, silk, and designer sarees from Tirupur, Monty
                Handloom Sarees is a dependable and quality-focused partner.
              </p>

              <li>
                <div className="pro_inner">
                  <div className="pro_img_sec">
                    <img
                      src="./assets/saree2.jpg"
                      title="SIDDHI COLLECTION Sarees"
                      alt="SIDDHI COLLECTION Sarees"
                      width="202"
                      height="299"
                      decoding="async"
                    />
                  </div>
                  <div className="products_info">
                    <div className="pro_title">
                      <h3>Elegant Designer Sarees</h3>
                    </div>
                    <div className="pro_det_sec">
                      <ul className="attributes">
                        <li>
                          <span>Brand:</span> SIDDHI COLLECTION
                        </li>
                        <li>
                          <span>Product:</span> Premium Designer Sarees for
                          Women
                        </li>
                        <li>
                          <span>Fabric:</span> Made from high-quality silk,
                          cotton, and georgette blends for luxurious comfort and
                          graceful drape.
                        </li>
                        <li>
                          <span>Designs:</span> Intricate embroidery, zari work,
                          and printed patterns in both traditional and
                          contemporary styles.
                        </li>
                        <li>
                          <span>Occasions:</span> Suitable for weddings, festive
                          events, parties, and formal gatherings.
                        </li>
                        <li>
                          <span>Colors:</span> Available in a wide palette
                          including vibrant hues, pastels, and classic shades.
                        </li>
                        <li>
                          <span>Length:</span> Standard 5.5 to 6.3 meters with
                          matching blouse piece included.
                        </li>
                        <li>
                          <span>Customization:</span> Blouse stitching and
                          custom tailoring options available on bulk orders.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <div className="company_header">
        <div className="top_head">
          <div className="company_left zdasds">
            <span className="logo_img2" style={{ background: "#d1d786" }}>
              SC
            </span>

            <div className="company_info">
              <div className="company_name2">
                <h1>
                  SIDDHI COLLECTION{" "}
                  <div className="_oth_info">
                    <a
                      href="https://www.google.co.in/maps/dir//12.9715987,77.5945627"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>
                        <b className="fa fa-map-marker" />
                        Madhya Pradesh, India
                      </span>
                    </a>
                  </div>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom_head">
          <div className={`Premium-Header ${highlight ? "highlight" : ""}`}>
            <ul className="menu_sec">
              <li>
                Home <FontAwesomeIcon icon={faGauge} />
              </li>
              <li>
                Products <FontAwesomeIcon icon={faShieldHalved} />
              </li>
              <li>
                About Us <FontAwesomeIcon icon={faMessage} />
                <ul className="dropdown"></ul>
              </li>
              <li>
                Contact Us <FontAwesomeIcon icon={faShieldHalved} />
                <ul className="dropdown"></ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {renderContent()}
    </>
  );
};

export default SiddhiCollectionCata;
